import React from "react";
import PropTypes from "prop-types";
import MenuComponent from "../component/MenuComponent";
import * as S from "../css/Vass.styles";
import { vassViewState } from "../stores/vass/vassViewState";
import { useRecoilValue } from "recoil";
import VassComponent1 from "../component/vass/VassComponent1";
import VassComponent2 from "../component/vass/VassComponent2";
import VassTestPlayer from "../component/vassTest/VassTestPlayer";

const FRIGATE_TEST_URL =
  "https://frigate.jhcon.net/vod/cam_2204/start/1768890585.667/end/1768890900.667/index.m3u8";

function Vasstest(props) {
  const vassView = useRecoilValue(vassViewState); // Vass 페이지 레이아웃 선택
  const renderTestPlayer = () => <VassTestPlayer url={FRIGATE_TEST_URL} />;

  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        {/* NOTE Vass UI 구성은 유지하면서 영상 영역만 테스트 플레이어로 교체 */}
        {vassView === "1" && (
          <VassComponent1 theme={props.theme} renderPlayer={renderTestPlayer} />
        )}
        {vassView === "2" && (
          <VassComponent2 theme={props.theme} renderCCTVView={renderTestPlayer} />
        )}
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

Vasstest.propTypes = {
  // NOTE 테마 객체는 styled-components에서 색상과 아이콘 경로를 가져오는 용도
  theme: PropTypes.shape({
    white1: PropTypes.string,
    black1: PropTypes.string,
    white4: PropTypes.string,
    icon: PropTypes.string,
  }).isRequired,
};

export default Vasstest;
